import axiosInstance from './axiosInstance';

const reactivateInvoice = ({ resourceType, resourceId }) =>
  axiosInstance.post('/internal/admin/invoices/reactivate', {
    resource_type: resourceType,
    resource_id: resourceId,
  });

export default reactivateInvoice;
